module.exports = __webpack_public_path__ + "img/podol.682f4f91.png";